module.exports = __webpack_public_path__ + "img/hero-image.adda5601.jpg";